import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Container, AboutMe, Skills, Profile } from './styles';
import Title from '../../UI/Title';
import Image from '../../UI/Image';

const AboutMeLayout = ({ aboutMeIcons, aboutMe, knowingMe, handleKnowingMe }) => (
  <Fragment>
    <Container id='about-me'>
      <AboutMe>
        <Title text={aboutMe.title} size='30px' />
        { aboutMe.info.map(item => <p key={item.id}>{item.paragraph}</p>) }
      </AboutMe>
      <Profile>
        <Image
          src='/images/profile.jpg'
          alt='my-profile'
          isProfile
        />
        { aboutMeIcons.map(item =>
          <Image
            isClass={item.isClass}
            key={item.id}
            src={item.src}
            alt={item.alt}
            style={{
              width: '40px',
              position: 'absolute',
              top: item.top,
              left: item.left
            }}
          />
        )}
      </Profile>
    </Container>
    <Skills>
      <button onClick={handleKnowingMe}>
        {aboutMe.skills.callToAction}
        <i className={`fas fa-chevron-${knowingMe ? 'up' : 'down'}`} />
      </button>

      { knowingMe &&
          <article>
            { aboutMe.skills.stacks.map(item =>
              <ul key={item.id}>
                <i className={item.icon} />
                <h4>{item.stack_title}</h4>
                <p>{item.technologies}</p>
              </ul>
            )}
          </article>
      }
    </Skills>
  </Fragment>
);

AboutMeLayout.propTypes = {
  aboutMeIcons: PropTypes.array,
  aboutMe: PropTypes.object,
  knowingMe: PropTypes.bool,
  handleKnowingMe: PropTypes.func
};

export default AboutMeLayout;
